import React from "react";

// Campo de formulario con su nombre arriba, para que se siga leyendo cuando ya tiene datos.
function CampoForm({ etiqueta, obligatorio = false, children }) {
  return (
    <label className="campo-form">
      <span>
        {etiqueta}
        {obligatorio && <b> *</b>}
      </span>
      {children}
    </label>
  );
}

export default CampoForm;
